<template>
    <div class="my-charts" :id="id"></div>
</template>

<script>
import * as echarts from 'echarts5'
export default {
    props: {
        id: {
            type: String,
            default: `echarts${Math.ceil(Math.random()*1000)}`
        },
        width: {
            type: Number,
            default: 0
        },
        height: {
            type: Number,
            default: 0
        },
        options: {
            type: Object,
            default: () => { return {} }
        }
    },
    data() {
        return {}
    },
    watch: {
        id(newV) {
            this.id = newV || `echarts${Math.ceil(Math.random()*1000)}`
        }
    },
    mounted() {
        this.myCharts()
    },
    methods: {

        myCharts() {
            const _this = this
            const myCharts = echarts.init(document.getElementById(_this.id))
            if(_this.width && _this.height) {
                myCharts.resize({
                    width: `${_this.width}px`,
                    height: `${_this.height}px`
                })
            }
            myCharts.setOption(_this.options)
        }
    }
}
</script>

<style lang="scss" scoped>
.my-charts {
    width: 100%;
    height: 100%;
}
</style>